import React from 'react';
import { Link } from 'react-router-dom';
import { useCategories } from '../../hooks/useProducts';
import { getImageUrl } from '../../services/api';

const ProductCategories = () => {
  const { categories, loading, error } = useCategories();

  if (loading) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center items-center min-h-[400px]">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-catalina-blue"></div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-red-600">
            <p>Error loading categories: {error}</p>
          </div>
        </div>
      </section>
    );
  }

  if (categories.length === 0) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-gray-600">
            <p>No categories available.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-catalina-blue mb-4">Product Categories</h2>
          <p className="text-lg text-gray-600">
            Browse our complete range of industrial equipment
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {categories.map((category) => {
            const backgroundImageUrl = category.BackgroundImage ? getImageUrl(category.BackgroundImage) : null;
            
            return (
              <Link
                key={category.id}
                to={`/products/${category.slug}`}
                className="group relative bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition duration-300 border border-gray-200 h-64"
              >
                {backgroundImageUrl ? (
                  <img
                    src={backgroundImageUrl}
                    alt={category.Name}
                    className="w-full h-full object-cover group-hover:scale-105 transition duration-300"
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-catalina-blue to-san-marino opacity-10"></div>
                )}
                
                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition duration-300 flex flex-col justify-end p-6">
                  <h3 className="text-xl font-bold text-white mb-2">{category.Name}</h3>
                  <p className="text-gray-100 text-sm mb-4">{category.Description || 'Explore our products in this category'}</p>
                  <div className="inline-flex items-center text-white font-semibold group-hover:translate-x-1 transition duration-300">
                    Learn More
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center">
          <Link
            to="/products/all"
            className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-300"
          >
            View All Products
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;